import { useFocusEffect } from "@react-navigation/native";
import React, { useMemo, useState } from "react";

import AlertModal from "@/components/molecules/AlertModal";
import { useCartController } from "@/contexts/CartControllerContext";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppDispatch, useAppSelector } from "@/hooks/application/store";
import { useShipmentValue } from "@/hooks/domain/shipmentValue";
import { RootNavigation } from "@/navigation/Root";
import { SET_SHIPMENT_VALUE } from "@/store/ducks/checkout";

import CartMobile from "./Cart.mobile";
import CartWeb from "./Cart.web";
import AddNotFoundItemsModal from "./components/AddNotFoundItemsModal";

const Cart = () => {
  const { isWebMode } = useViewport();
  const dispatch = useAppDispatch();
  const { navigate, isFocused } = useAppNavigation<RootNavigation>();

  const [modalVisible, setModalVisible] = useState(false);
  const [modalShipmentErrorVisible, setModalShipmentErrorVisible] = useState(false);

  const { items, shipmentValue, store, subtotal, itemsNotFound } = useAppSelector(
    (store) => store.checkout
  );

  const { data: shipmentData, isError } = useShipmentValue(store?._id, {
    enabled: !!store?._id,
    onError: () => {
      dispatch(SET_SHIPMENT_VALUE(null));
      setModalShipmentErrorVisible(true);
    },
  });

  const { clearCart, initializeCheckout, changeNotFoundItems } = useCartController();

  useFocusEffect(() => {
    const value = shipmentData?.shipmentValue;
    if (!isError && value !== null && value !== undefined && value !== shipmentValue) {
      dispatch(SET_SHIPMENT_VALUE(value));
    }
  });

  const onPressContinue = () => {
    initializeCheckout();
  };

  const Screen = useMemo(() => (isWebMode ? CartWeb : CartMobile), [isWebMode]);

  return (
    <>
      <Screen
        items={Array.from(items.values())}
        shipmentValue={shipmentValue}
        store={store}
        subtotal={subtotal}
        onPressClear={clearCart}
        onPressContinue={onPressContinue}
        onPressNotFoundItem={() => setModalVisible(true)}
      />
      <AddNotFoundItemsModal
        modalVisible={modalVisible}
        notFoundItemsText={itemsNotFound}
        onSubmit={(text) => {
          changeNotFoundItems(text);
          setModalVisible(false);
        }}
        onClose={() => setModalVisible(false)}
      />
      <AlertModal
        isOpen={isFocused() && modalShipmentErrorVisible}
        title="Endereço indisponível"
        message="Este estabelecimento não atende o endereço selecionado, por escolha outro endereço."
        onClose={() => {
          setModalShipmentErrorVisible((prev) => !prev);
        }}
        onPressPrimaryButton={() => {
          setModalShipmentErrorVisible((prev) => !prev);
          navigate("addressStack");
        }}
      />
    </>
  );
};

export default Cart;
